export default class SepaDirectDebitExportAvailability {
    constructor() {
        this.isAvailable = false;
        this.hasSepaBankAccount = false;
        this.hasCreditorIdentifier = false;
        this.hasInvoices = false;
        this.hasRunningExport = false;
        this.incompleteMembers = [];
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const availability = new SepaDirectDebitExportAvailability();
        availability.isAvailable = data.isAvailable;
        availability.hasSepaBankAccount = data.hasSepaBankAccount;
        availability.hasCreditorIdentifier = data.hasCreditorIdentifier;
        availability.hasInvoices = data.hasInvoices;
        availability.hasRunningExport = data.hasRunningExport;
        availability.incompleteMembers = data.incompleteMembers ?? [];

        return availability;
    }
}
